<template>
  <div>
    <v-row fill-height align="center" justify="center" style="margin:0">
      <span v-if="units.count == 0">Tidak Ada Data</span>
    </v-row>

    <v-row>
      <v-col v-for="item in units.data" :key="item.id" cols="12" md="4">
        <v-card elevation="7" class="mx-auto">
          <v-list-item>
            <v-list-item-avatar color="grey"></v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>{{ item.nama }}</v-list-item-title>
              <v-list-item-subtitle v-if="item.iklan">
                {{ item.iklan.judul }}</v-list-item-subtitle
              >
            </v-list-item-content>
            <v-list-item-action>
              <v-list-item-action-text
                v-text="item.id_iklan"
              ></v-list-item-action-text>
            </v-list-item-action>
          </v-list-item>

          <v-img
            v-if="item.iklan"
            :src="$url_img + item.iklan.photo"
            height="194"
          ></v-img>

          <v-list-item>
            <v-list-item-content>
              <v-list-item-subtitle v-if="item.iklan"
                >Nominal Simotor : {{ item.total_harga_simotor }}</v-list-item-subtitle
              >
              <v-list-item-subtitle v-if="item.iklan"
                >Nominal User : {{ item.total_harga_penjual }}</v-list-item-subtitle
              >
            </v-list-item-content>
          </v-list-item>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn icon @click="onDetail(item.id)">
              <v-icon>mdi-grease-pencil</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import moment from 'moment';
export default {
  name: 'Moderasi',
  props: {
    units: { Array },

    onDetail: Function
  },
  data() {
    return {};
  },
  filters: {
    countDoc(doc) {
      if (doc !== null) {
        return true;
      }
    },
    datediff: date => {
      return moment(date).from();
    },
    dateFormat: date => {
      return moment.utc(date).format('DD MMM YYYY');
    },
    timeFormat: date => {
      return moment.utc(date).format('HH:mm');
    },
    dateTimeFormat: date => {
      return moment.utc(date).format('DD MMM YYYY HH:mm');
    }
  },
  methods: {}
};
</script>
